import { useAppDispatch } from "hooks/storeHooks"
import React, { useEffect, useState } from "react"
import { setTypes } from "store/product/productSlice"
import { initializeUser } from "store/user/userThunks"
import { Box } from "@strapi/design-system"
import { tintVTOService } from "services/tintvto"

const Initializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch()
  const [isInitializing, setIsInitializing] = useState(true)

  useEffect(() => {
    const init = async () => {
      await dispatch(initializeUser())
      setIsInitializing(false)
      const { data } = await tintVTOService.types()
      const types = data?.types ?? []

      dispatch(setTypes(types))
    }

    void init()
  }, [dispatch])

  if (isInitializing)
    return (
      <Box
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    )

  return <>{children}</>
}

export default Initializer
